import React, { useEffect, useState } from "react";
import OneIcon from "../../Images/oneIcon.svg";
import PreCheckBarGreen from "../../Images/preCheck/preCheckGreen.svg";
import checkGreen from "../../Images/preCheck/checkGreen.svg";
import LoadingSpinner from "../Lottie/LoadingSpinner";

function Prechecks(probs) {



  const {scrollToBottom,addMessagesBoiler} = probs
  
  const [onChecked, setOnChecked] = useState(false);
  const [loader, setLoader] = useState(false);

  const loadingTimeOut = () => {
    setLoader(true);
    setTimeout(() => {
      setOnChecked(true);
      setLoader(false);
    }, 3000); // 3 seconds loader
  };

  useEffect(()=>{
    setLoader(true);
    setTimeout(() => {
      setOnChecked(true);
      setLoader(false);

      addMessagesBoiler(true ,'askQuestions')
     
    }, 3000); // 3 seconds loader
  },[])

  useEffect(()=>{
    scrollToBottom()
  },[loader])

  const srr = [
    "Cyclone",
    "IVR Downtime",
    "Internet Services Suspended",
    "Riots",
    "Bandh",
    "Floods",
    "Heavy Rainfall",
    "Local Cable Operator Issue",
  ];

  return (
    <div>
      <div style={{ padding: "8px" }} className="header-prob">
        Checklist
      </div>
      <div className="channel-list">
        <div style={{ borderRadius: "8px" }} className="list-of-channels">
          <div
            // onClick={loadingTimeOut}
            style={{
              border: onChecked ? "1px solid #43BF5E" : "1px solid #ccc",
              backgroundColor: onChecked ? "#EAF8ED" : "#fff",
              borderBottom: onChecked ? "none" : "1px solid #ccc",
              height: "64px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              borderRadius: onChecked ? "10px 10px 0px 0px" : "10px",
              cursor: "pointer",
            }}
            className="precheck-header"
          >
            <img
              key={"num"}
              src={OneIcon}
              style={{
                height: "clamp(32px, 4vw, 72px)",
                width: "clamp(16px, 4vw, 32px)",
              }}
            />
            <div>Briefing</div>
          </div>

          {/* Smooth expanding section */}
          <div
            style={{
              height: onChecked ? "304px" : "0px", // Smooth transition on height
              opacity: 1,
              overflow: "hidden", // Hide overflow during transition
              borderRadius: "10px",
              border: onChecked ? "1px solid #43BF5E" : "none",
              backgroundColor: "#fff",
              transition: "height 0.5s ease", // Smooth height transition
              display: "flex",
              // flexDirection: "column",
              gap: "16px",
              bottom : '10px',
              position : 'relative',
            }}
            className="precheck-header"
          >
            {onChecked && (
              <>
                <img
                  style={{ width: "34px" }}
                  key={"num"}
                  src={PreCheckBarGreen}
                />
                <div>
                  {srr.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          margin: "10px 10px 10px 0px",
                          display: "flex",
                          gap: "10px",
                        }}
                      >
                        <img
                          style={{ width: "16px" }}
                          key={"num"}
                          src={checkGreen}
                        />
                        <span className="precheck-flow-font">{item}</span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
        {loader && <LoadingSpinner />}
      </div>
    </div>
  );
}

export default Prechecks;
